import script from "./rcentlyViewedProd.vue?vue&type=script&setup=true&name=rcentlyViewedProd&lang=js"
export * from "./rcentlyViewedProd.vue?vue&type=script&setup=true&name=rcentlyViewedProd&lang=js"

const __exports__ = script;

export default __exports__